/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LogErrorDto } from '../models/LogErrorDto';
import type { RegisterDeviceDto } from '../models/RegisterDeviceDto';
import type { UpdateablePassesResponseDto } from '../models/UpdateablePassesResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PassKitService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Register a device to receive push notifications for a pass
   * POST /v1/devices/:deviceLibraryIdentifier/registrations/:passTypeIdentifier/:serialNumber
   * @returns any
   * @throws ApiError
   */
  public registerDevice({
    deviceLibraryIdentifier,
    passTypeIdentifier,
    serialNumber,
    requestBody,
  }: {
    deviceLibraryIdentifier: string,
    passTypeIdentifier: string,
    serialNumber: string,
    requestBody: RegisterDeviceDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/wallet-pass/passkit/v1/devices/{deviceLibraryIdentifier}/registrations/{passTypeIdentifier}/{serialNumber}',
      path: {
        'deviceLibraryIdentifier': deviceLibraryIdentifier,
        'passTypeIdentifier': passTypeIdentifier,
        'serialNumber': serialNumber,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Unregister a device
   * DELETE /v1/devices/:deviceLibraryIdentifier/registrations/:passTypeIdentifier/:serialNumber
   * @returns any
   * @throws ApiError
   */
  public unregisterDevice({
    deviceLibraryIdentifier,
    passTypeIdentifier,
    serialNumber,
  }: {
    deviceLibraryIdentifier: string,
    passTypeIdentifier: string,
    serialNumber: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/v1/wallet-pass/passkit/v1/devices/{deviceLibraryIdentifier}/registrations/{passTypeIdentifier}/{serialNumber}',
      path: {
        'deviceLibraryIdentifier': deviceLibraryIdentifier,
        'passTypeIdentifier': passTypeIdentifier,
        'serialNumber': serialNumber,
      },
    });
  }
  /**
   * Get serial numbers for passes that have changed
   * GET /v1/devices/:deviceLibraryIdentifier/registrations/:passTypeIdentifier?passesUpdatedSince=timestamp
   *
   * Note: Per Apple's PassKit Web Service spec, this endpoint does NOT require authentication.
   * The auth token is only required for register, unregister, and get-pass endpoints.
   * We validate that the device exists to prevent enumeration attacks.
   * @returns UpdateablePassesResponseDto
   * @throws ApiError
   */
  public getUpdatablePasses({
    deviceLibraryIdentifier,
    passTypeIdentifier,
    passesUpdatedSince,
  }: {
    deviceLibraryIdentifier: string,
    passTypeIdentifier: string,
    passesUpdatedSince: string,
  }): CancelablePromise<UpdateablePassesResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/wallet-pass/passkit/v1/devices/{deviceLibraryIdentifier}/registrations/{passTypeIdentifier}',
      path: {
        'deviceLibraryIdentifier': deviceLibraryIdentifier,
        'passTypeIdentifier': passTypeIdentifier,
      },
      query: {
        'passesUpdatedSince': passesUpdatedSince,
      },
    });
  }
  /**
   * Get the latest version of a pass
   * GET /v1/passes/:passTypeIdentifier/:serialNumber
   *
   * Streams the pass directly instead of redirecting to S3 to ensure
   * Apple Wallet receives proper headers and content.
   * @returns any
   * @throws ApiError
   */
  public getLatestPass({
    passTypeIdentifier,
    serialNumber,
  }: {
    passTypeIdentifier: string,
    serialNumber: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/wallet-pass/passkit/v1/passes/{passTypeIdentifier}/{serialNumber}',
      path: {
        'passTypeIdentifier': passTypeIdentifier,
        'serialNumber': serialNumber,
      },
    });
  }
  /**
   * Log errors from devices
   * POST /v1/log
   * @returns any
   * @throws ApiError
   */
  public logErrors({
    requestBody,
  }: {
    requestBody: LogErrorDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/wallet-pass/passkit/v1/log',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
